import React, { useEffect } from "react";
import classNames from "classnames";
import HeaderLinks from "components/Header/HeaderLinks";
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";

import { $FIXME } from "Helpers/constants";
import { Grid, Container } from "@mui/material";
import Parallax from "components/Parallax/Parallax";
import useStyles from "assets/styles";
import { Helmet } from "react-helmet";
import { envirnoment } from "envirnoment";

export default function FAQPage(props: $FIXME) {
	const classes = useStyles();
	const { ...rest } = props;

	useEffect(() => {
		(window as Window).scrollTo(0, 0);
	}, []);

	return (
		<div style={{ overflow: "hidden" }}>
			<Helmet>
				<base />
				<title>My Cleaner Help | FAQ how to find Cleaners in my area? </title>
				<meta
					name="description"
					content="Check out our FAQ's to get the latest answers questions. We've answered some of the most commonly asked questions about our cleaning services."
				/>
				<link rel="canonical" href={envirnoment.websiteURL + "/faq"} />
			</Helmet>
			<Header
				color="transparent"
				brand="My Cleaner Help"
				rightLinks={<HeaderLinks />}
				fixed
				changeColorOnScroll={{
					height: 200,
					color: "white",
				}}
				{...rest}
			/>
			<Parallax small image="/img/home/cleaning_services.webp">
				<div className={classes.container}>
					<Grid container style={{ zIndex: 19 }}>
						<Grid
							item
							xs={12}
							sm={12}
							md={12}
							className={classes.justifyCenter}
						>
							<h1 className={classes.titleWhite}>Frequently Asked Questions</h1>
						</Grid>
					</Grid>
				</div>
			</Parallax>
			<div className={classNames(classes.main, classes.mainRaised)}>
				<Container>
					<Grid container className={classes.justifyCenter}>
						<Grid item xs={12} sm={12} md={8}>
							<h3 className={classes.title}>
								Check out our FAQ to see if your question has been answered
								below. Feel free to reach out with other questions too!
							</h3>
						</Grid>
					</Grid>
					<Grid container spacing={5}>
						<Grid item xs={12} sm={12} md={6}>
							<h2 className={classes.title}>DO YOU SERVICE MY AREA?</h2>
							<p className={classes.description}>
								We serve most areas of your city and its surroundings. If you
								are outside of these areas, please contact us before booking a
								service to see if we serve your location.
							</p>
						</Grid>
						<Grid item xs={12} sm={12} md={6}>
							<h2 className={classes.title}>WHAT IS INCLUDED?</h2>
							<p className={classes.description}>
								Our full list of services is available on our services page. If
								there is something not listed that you would like to do, please
								contact us prior to booking and we will do our best to
								accommodate your request.
							</p>
						</Grid>
					</Grid>

					<Grid container spacing={5}>
						<Grid item xs={12} sm={12} md={6}>
							<h2 className={classes.title}>HOW MUCH WILL MY CLEANING COST?</h2>
							<p className={classes.description}>
								All our prices are available on our reservation page. We offer
								flat rates for full house cleaning as well as hourly cleaning.
								All additional services will be added to the final amount of
								your service.
							</p>
						</Grid>
						<Grid item xs={12} sm={12} md={6}>
							<h2 className={classes.title}>DO I NEED TO PROVIDE ANYTHING?</h2>
							<p className={classes.description}>
								Our Partners can provide the necessary basic supplies for a
								small fee that can be specified in the reservation or you can
								provide the products yourself. We can provide you with a list of
								the products you need if you decide to buy them yourself. If you
								have specific cleaning products or supplies that you would like
								to use, just let us know when you book
							</p>
						</Grid>
					</Grid>

					<Grid container spacing={5}>
						<Grid item xs={12} sm={12} md={6}>
							<h2 className={classes.title}>
								IS MY BILLING INFORMATION KEPT SECURE?
							</h2>
							<p className={classes.description}>
								Our website uses an SSL to ensure that your personal information
								is encrypted and is never compromised in any way
							</p>
						</Grid>
						<Grid item xs={12} sm={12} md={6}>
							<h2 className={classes.title}>ARE THE CLEANERS VERIFIED?</h2>
							<p className={classes.description}>
								Yes. Your safety and the safety of your home are of the utmost
								importance to us. All of our professional collaborators go
								through interviews and provide proof of identification and right
								to work before being hired.
							</p>
						</Grid>
					</Grid>

					<Grid container spacing={5}>
						<Grid item xs={12} sm={12} md={6}>
							<h2 className={classes.title}>WHAT'S YOUR REFUND POLICY?</h2>
							<p className={classes.description}>
								If you are not completely satisfied with your service, your
								cleaning crew will return to your home to complete the missing
								areas. If you are still not satisfied after the cleaning is
								completed, we will issue a refund.
							</p>
						</Grid>
						<Grid item xs={12} sm={12} md={6}>
							<h2 className={classes.title}>HOW DO I BOOK A SERVICE?</h2>
							<p className={classes.description}>
								You can book any of our cleaning services by visiting our online
								booking page. Services can be booked online in seconds, all we
								need is a little information about your home and what you would
								like to see done during your service.
							</p>
						</Grid>
					</Grid>
				</Container>
			</div>
			<Footer />
		</div>
	);
}
